import { writable } from 'svelte/store';
import type { Player } from '@blather/shared';

interface PlayerState {
  player: Player | null;
  username: string;
  lobbyId: string;
}

export const playerStore = writable<PlayerState>({
  player: null,
  username: '',
  lobbyId: '',
});

export function setPlayer(player: Player, username: string, lobbyId: string): void {
  playerStore.set({ player, username, lobbyId });
}

export function updatePlayerInfo(username: string, lobbyId: string): void {
  playerStore.update((state) => ({ ...state, username, lobbyId }));
}

export function clearPlayer(): void {
  playerStore.set({ player: null, username: '', lobbyId: '' });
}
